import CustomFormField from './CustomFormField';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CustomFormFields = ({
  disabled,
  formFields,
  onChange,
  values
}) => /*#__PURE__*/_jsx(_Fragment, {
  children: formFields.map(formField => /*#__PURE__*/_jsx(CustomFormField, {
    disabled: disabled,
    formField: formField,
    onChange: event => onChange(formField.name, event),
    value: values[formField.name]
  }, formField.name))
});
export default CustomFormFields;